import { SubMenu } from "react-pro-sidebar";
import income from "../../../images/newDesign/income.svg";
import IncomeActionsSidebarMenu from "./incomeActionsSidebarMenu";
import IncomeReportsSidebarMenu from "./incomeReportsSidebarMenu";
import { useTranslation } from "react-i18next";

/**
 * @param buildingId
 * @param year
 * @param apartmentNumber
 * @param navData
 * @return {JSX.Element|null}
 * @constructor
 */
export default function IncomeSidebarMenu({buildingId, year, apartmentNumber, navData}) {
    const { t } = useTranslation();

    return (
        <SubMenu
            title={t('buildings.incomes')}
            icon={<img src={income} alt="buildings.incomes"/>}>
            <IncomeActionsSidebarMenu buildingId={buildingId}/>
            <IncomeReportsSidebarMenu year={year} apartmentNumber={apartmentNumber} navData={navData}/>
        </SubMenu>
    )
}
